@if (selectedClient) {
	<nz-table #purchaseTable [nzData]="purchases" [nzLoading]="purchaseService.loading$ | async" [nzNoResult]="noData">
		<thead>
			<tr>
				<th>Purchase Date</th>
				<th>Invoice ID</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			@for (purchase of purchases; track purchase) {
				<tr [class.selected]="purchase.uuid === purchaseService.selectedPurchaseBs$.value?.uuid">
					<td>{{ purchase.purchase_date | date: 'mediumDate' }}</td>
					<td>{{ purchase.invoice_id }}</td>
					<td>
						@if (mode === 'edit') {
							@if (purchase.uuid === purchaseService.selectedPurchaseBs$.value?.uuid) {
								<button nz-button (click)="selectPurchase(undefined)">Clear</button>
							}
							@if (purchase.uuid !== purchaseService.selectedPurchaseBs$.value?.uuid) {
								<button nz-button nzType="primary" (click)="selectPurchase(purchase)">Edit</button>
							}
						}
						@if (mode === 'select') {
							<button nz-button nzType="primary" (click)="selectPurchase(purchase)">Select</button>
						}
					</td>
				</tr>
			}
		</tbody>
		<ng-template #noData>
			<nz-typography>No purchases available</nz-typography>
		</ng-template>
	</nz-table>
}
